<!-- <div class="prodDetailInfo" id="pdtDetailInfo">
    <div class="detailReview" id="detailReview">
      <ul class="prodDetailTab">
          <li class="on">
              <a
                  href="javascript:void()"
                  (click)="scrollElement('detailReview')"
                  >{{'product.content.lbl.003' | translate}}</a
              >
          </li>
          <li>
              <a
                  href="javascript:void()"
                  (click)="scrollElement('detailPurchase')"
                  >Product Description</a
              >
          </li>
          <li>
              <a href="javascript:void()" (click)="scrollElement('detailImg')"
                  >{{'product.content.lbl.001' | translate}}</a
              >
          </li>
      </ul>
      <div class="review">
          <h2>
              {{ 'product.review.lbl.001' | translate }}
              <span>({{ total }})</span>
              <a (click)="viewAll()">{{
                  'product.review.lbl.002' | translate
              }}</a>
          </h2>
          <dl class="reviewTop">
              <dt>
                  <div class="average d-flex justify-content-center">
                      <div class="star-ratings">
                          <div
                              class="fill-ratings"
                              style="width: 0%"
                              id="fill-rating-review"
                          >
                              <span>★</span>
                          </div>
                          <div class="empty-ratings">
                              <span>★</span>
                          </div>
                      </div>
                      {{ avgGrade }}
                  </div>
                  <p>
                      <strong>{{ percentRating }}%</strong
                      >{{ 'product.review.lbl.003' | translate }}
                  </p>
                  <a (click)="onClickShowReviewPopup()">{{
                      'product.review.lbl.004' | translate
                  }}</a>
              </dt>
              <dd>
                  <ul>
                      <li>
                          <div class="title">
                              {{ 'product.review.lbl.005' | translate }}
                          </div>
                          <div class="gauge">
                              <span style="width: 0%" id="g5Rate"></span>
                          </div>
                          <div class="count">{{ total5Grade }}</div>
                      </li>
                      <li>
                          <div class="title">
                              {{ 'product.review.lbl.006' | translate }}
                          </div>
                          <div class="gauge">
                              <span style="width: 0%" id="g4Rate"></span>
                          </div>
                          <div class="count">{{ total4Grade }}</div>
                      </li>
                      <li>
                          <div class="title">
                              {{ 'product.review.lbl.007' | translate }}
                          </div>
                          <div class="gauge">
                              <span style="width: 0%" id="g3Rate"></span>
                          </div>
                          <div class="count">{{ total3Grade }}</div>
                      </li>
                      <li>
                          <div class="title">
                              {{ 'product.review.lbl.008' | translate }}
                          </div>
                          <div class="gauge">
                              <span style="width: 0%" id="g2Rate"></span>
                          </div>
                          <div class="count">{{ total2Grade }}</div>
                      </li>
                      <li>
                          <div class="title">
                              {{ 'product.review.lbl.009' | translate }}
                          </div>
                          <div class="gauge">
                              <span style="width: 0%" id="g1Rate"></span>
                          </div>
                          <div class="count">{{ total1Grade }}</div>
                      </li>
                  </ul>
              </dd>
          </dl>
          <h3>
              {{ 'product.review.lbl.010' | translate }}
              <span>({{ totalProductReviewImage }})</span>
            
          </h3>
          <ng-container *ngIf="productReviewImages.length !== 0">
              <ul class="reviewMedia">
                  <ng-container *ngFor="let item of productReviewImages">
                      <li>
                          <a href="javascript:void()"
                              ><img
                                  [src]="
                                      urlWownet +
                                      '/' +
                                      item.filePath +
                                      '/' +
                                      item.fileName
                                  "
                                  alt=""
                          /></a>
                      </li>
                  </ng-container>
              </ul>
          </ng-container>
          <div class="reviewTabWrap">
              <ul class="reviewTab">
                  <li>
                      <a
                          [ngClass]="orderBy == 'new' ? 'on' : ''"
                          (click)="onOrderBy('new')"
                          >{{ 'product.review.lbl.011' | translate }}</a
                      >
                  </li>
                  <li>
                      <a
                          [ngClass]="orderBy == 'best' ? 'on' : ''"
                          (click)="onOrderBy('best')"
                          >{{ 'product.review.lbl.012' | translate }}</a
                      >
                  </li>
              </ul>
              
          </div>
          <ng-container
              *ngFor="let item of pdtReviews; index as i"
          >
              <div class="reviewCont">
                  <div class="reviewLeft">
                      <ul class="reiveTit">
                          <li>
                              <ng-container [ngSwitch]="item.grade">
                                  <span *ngSwitchCase="'1'">★ </span>
                                  <span *ngSwitchCase="'2'">★★ </span>
                                  <span *ngSwitchCase="'3'">★★★ </span>
                                  <span *ngSwitchCase="'4'">★★★★ </span>
                                  <span *ngSwitchCase="'5'">★★★★★ </span>
                                  <span *ngSwitchDefault></span>
                              </ng-container>
                              <span>{{ item.title }}</span>
                          </li>
                          <li>{{ item.insDate }}</li>
                      </ul>
                      <p
                          [innerHTML]="
                              item.cmnt ? (item.cmnt | renderHtml) : ''
                          "
                      ></p>
                      <ng-container
                          *ngIf="
                              item.filePath != null && item.fileName != null
                          "
                      >
                          <div class="imgWrap">
                              <a href="javascript:void()">
                                  <img
                                      [src]="
                                          urlWownet +
                                          '/' +
                                          item.filePath +
                                          '/' +
                                          item.fileName
                                      "
                                      alt=""
                                  />
                              </a>
                          </div>
                      </ng-container>
                      <ul class="reviewBtn">
                          <li>
                              <a href="javascript:void()">
                                  <svg
                                      (click)="
                                          callCommentPdt(item, i, 'N', '')
                                      "
                                      *ngIf="isLike(item.seq) == 'Y'"
                                      xmlns="http://www.w3.org/2000/svg"
                                      class="icon icon-tabler icon-tabler-thumb-up"
                                      width="32"
                                      height="32"
                                      viewBox="0 0 24 24"
                                      stroke-width="1.5"
                                      stroke="#000000"
                                      fill="#0632c2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                  >
                                      <path
                                          stroke="none"
                                          d="M0 0h24v24H0z"
                                          fill="none"
                                      />
                                      <path
                                          d="M7 11v8a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-7a1 1 0 0 1 1 -1h3a4 4 0 0 0 4 -4v-1a2 2 0 0 1 4 0v5h3a2 2 0 0 1 2 2l-1 5a2 3 0 0 1 -2 2h-7a3 3 0 0 1 -3 -3"
                                      />
                                  </svg>
  
                                  <svg
                                      (click)="
                                          callCommentPdt(item, i, 'Y', '')
                                      "
                                      *ngIf="isLike(item.seq) != 'Y'"
                                      xmlns="http://www.w3.org/2000/svg"
                                      class="icon icon-tabler icon-tabler-thumb-up"
                                      width="32"
                                      height="32"
                                      viewBox="0 0 24 24"
                                      stroke-width="1.5"
                                      stroke="#000000"
                                      fill="none"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                  >
                                      <path
                                          stroke="none"
                                          d="M0 0h24v24H0z"
                                          fill="none"
                                      />
                                      <path
                                          d="M7 11v8a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-7a1 1 0 0 1 1 -1h3a4 4 0 0 0 4 -4v-1a2 2 0 0 1 4 0v5h3a2 2 0 0 1 2 2l-1 5a2 3 0 0 1 -2 2h-7a3 3 0 0 1 -3 -3"
                                      />
                                  </svg>
                                  {{ 'product.review.lbl.014' | translate }} {{listQtyLike[i]}}
                              </a>
                          </li>
                          <li>
                              <a href="javascript:void()">
                                  <svg
                                      (click)="
                                          callCommentPdt(item, i, '', 'N')
                                      "
                                      *ngIf="isUnLike(item.seq) == 'Y'"
                                      xmlns="http://www.w3.org/2000/svg"
                                      class="icon icon-tabler icon-tabler-thumb-down"
                                      width="32"
                                      height="32"
                                      viewBox="0 0 24 24"
                                      stroke-width="1.5"
                                      stroke="#000000"
                                      fill="#0632c2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                  >
                                      <path
                                          stroke="none"
                                          d="M0 0h24v24H0z"
                                          fill="none"
                                      />
                                      <path
                                          d="M7 13v-8a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v7a1 1 0 0 0 1 1h3a4 4 0 0 1 4 4v1a2 2 0 0 0 4 0v-5h3a2 2 0 0 0 2 -2l-1 -5a2 3 0 0 0 -2 -2h-7a3 3 0 0 0 -3 3"
                                      />
                                  </svg>
  
                                  <svg
                                      (click)="
                                          callCommentPdt(item, i, '', 'Y')
                                      "
                                      *ngIf="isUnLike(item.seq) != 'Y'"
                                      xmlns="http://www.w3.org/2000/svg"
                                      class="icon icon-tabler icon-tabler-thumb-down"
                                      width="32"
                                      height="32"
                                      viewBox="0 0 24 24"
                                      stroke-width="1.5"
                                      stroke="#000000"
                                      fill="none"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                  >
                                      <path
                                          stroke="none"
                                          d="M0 0h24v24H0z"
                                          fill="none"
                                      />
                                      <path
                                          d="M7 13v-8a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v7a1 1 0 0 0 1 1h3a4 4 0 0 1 4 4v1a2 2 0 0 0 4 0v-5h3a2 2 0 0 0 2 -2l-1 -5a2 3 0 0 0 -2 -2h-7a3 3 0 0 0 -3 3"
                                      />
                                  </svg>
  
                                  {{ 'product.review.lbl.015' | translate }}  {{listQtyUnLike[i]}}
                              </a>
                          </li>
                          <li>
                              <a href="javascript:void()">
                                  <svg *ngIf="!isOpen(i)" (click)="openCmntPdt(i)" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <path
                                          d="M8.56559 3H13.4858C17.1828 3 20.1798 5.99701 20.1798 9.694C20.1798 10.2331 20.1321 10.7711 20.0371 11.3017L19.5425 14.0662C19.2016 15.9716 19.4815 17.9361 20.341 19.6704C20.5812 20.155 20.1107 20.686 19.6007 20.506L17.9899 19.9373C16.2528 19.324 14.4176 19.036 12.5761 19.0876L12.1333 19.1H8.86667C5.25841 19.1 2.33334 16.1749 2.33334 12.5667L2.33333 9.23226C2.33333 5.79028 5.12361 3 8.56559 3Z"
                                          stroke="#222628" stroke-width="1.4" />
                                      <circle cx="0.666667" cy="0.666667" r="0.666667" transform="matrix(-1 0 0 1 15 11)" fill="#222628" />
                                      <circle cx="0.666667" cy="0.666667" r="0.666667" transform="matrix(-1 0 0 1 12.3333 11)" fill="#222628" />
                                      <circle cx="0.666667" cy="0.666667" r="0.666667" transform="matrix(-1 0 0 1 9.66667 11)" fill="#222628" />
                                  </svg>
                                  <svg *ngIf="isOpen(i)" (click)="closeCmntPdt(i)" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <path
                                          d="M8.56559 3H13.4858C17.1828 3 20.1798 5.99701 20.1798 9.694C20.1798 10.2331 20.1321 10.7711 20.0371 11.3017L19.5425 14.0662C19.2016 15.9716 19.4815 17.9361 20.341 19.6704C20.5812 20.155 20.1107 20.686 19.6007 20.506L17.9899 19.9373C16.2528 19.324 14.4176 19.036 12.5761 19.0876L12.1333 19.1H8.86667C5.25841 19.1 2.33334 16.1749 2.33334 12.5667L2.33333 9.23226C2.33333 5.79028 5.12361 3 8.56559 3Z"
                                          stroke="#222628" stroke-width="1.4" />
                                      <circle cx="0.666667" cy="0.666667" r="0.666667" transform="matrix(-1 0 0 1 15 11)" fill="#222628" />
                                      <circle cx="0.666667" cy="0.666667" r="0.666667" transform="matrix(-1 0 0 1 12.3333 11)" fill="#222628" />
                                      <circle cx="0.666667" cy="0.666667" r="0.666667" transform="matrix(-1 0 0 1 9.66667 11)" fill="#222628" />
                                  </svg>
                                  {{ 'product.review.lbl.016' | translate }}
                                  <span>{{ item.commentCnt }}</span>
                              </a>
                          </li>
                      </ul>
                      <div class="commentCont">
                          <input
                              type="text"
                              placeholder="댓글을 작성해 주세요."
                          />
                      </div>
                  </div>
              </div>
              <div *ngIf="isOpen(i)">
                  <ng-container *ngFor="let cmnt of listComment">
                      <ng-container *ngIf="cmnt.seq == item.seq && cmnt.cmnt != ''">
                          <p>{{ cmnt.cmnt }}</p>
                      </ng-container>
                  </ng-container>
                  <div class="review-Wrap-Input">
                      <input type="text" [(ngModel)]="cmnt[i]" />
                      <button class="btn-comment" (click)="callCommentPdt(item, i, '', '')">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M20.7515 2.31457C21.0458 2.50096 21.3036 2.75324 21.4964 3.04343C21.8598 3.59061 21.8809 4.22735 21.7946 4.88638C21.7099 5.53249 21.4991 6.34591 21.2403 7.34455L21.2281 7.39151C20.6516 9.61581 20.0069 12.0766 19.5402 13.7808C19.2066 14.9993 18.7813 16.3911 18.3549 17.7272L18.3397 17.7747C18.0053 18.8228 17.7338 19.6733 17.4448 20.2974C17.1514 20.9309 16.7735 21.4841 16.1378 21.7459C15.8042 21.8833 15.4338 21.9479 15.0734 21.9317C14.3844 21.9007 13.8386 21.5026 13.345 21.0015C12.8574 20.5064 12.307 19.7892 11.6275 18.9037L9.05787 15.5551C8.92373 15.3803 8.8883 15.3358 8.85116 15.2974C8.8367 15.2824 8.82182 15.2678 8.80653 15.2537C8.76727 15.2174 8.72201 15.183 8.5443 15.0527L4.97167 12.4343C4.11696 11.8079 3.41956 11.2968 2.93493 10.8345C2.43839 10.3607 2.04905 9.83246 2.0049 9.15033C1.98181 8.79368 2.04088 8.4126 2.17086 8.07967C2.41807 7.44645 2.93877 7.06229 3.54726 6.76307C4.13784 6.47266 4.93993 6.20251 5.9195 5.87257L5.96825 5.85615C7.16566 5.45281 8.54272 5.00655 10.0818 4.53536C12.3422 3.84337 14.5521 3.2024 16.4288 2.67217L16.4756 2.65895C17.4621 2.38022 18.2663 2.15298 18.9076 2.05516C19.5626 1.95524 20.1973 1.9636 20.7515 2.31457ZM20.3302 3.81803C20.2463 3.69169 20.1306 3.57848 20.0024 3.49733C19.8776 3.41828 19.6597 3.35662 19.1187 3.43915C18.574 3.52224 17.8541 3.72428 16.8094 4.01943C14.9395 4.54773 12.7398 5.18578 10.4917 5.87404C8.9656 6.34122 7.60092 6.78348 6.41516 7.1829C5.37481 7.53333 4.66215 7.77495 4.16504 8.0194C3.67608 8.25984 3.53344 8.43911 3.47499 8.58881C3.41945 8.73108 3.39211 8.90749 3.40197 9.0599C3.41211 9.21649 3.49471 9.43356 3.90134 9.82151C4.31214 10.2134 4.93455 10.6714 5.8403 11.3352L9.37189 13.9235C9.3802 13.9296 9.3884 13.9356 9.39652 13.9416C9.53839 14.0455 9.65175 14.1285 9.75671 14.2255C9.79145 14.2576 9.82527 14.2907 9.85814 14.3247C9.95743 14.4275 10.0429 14.539 10.15 14.6786C10.1561 14.6866 10.1623 14.6946 10.1685 14.7028L12.708 18.0121C13.4248 18.9462 13.923 19.5933 14.3424 20.0191C14.7632 20.4463 14.9884 20.5265 15.1364 20.5331C15.2929 20.5402 15.4599 20.511 15.6047 20.4514C15.7437 20.3942 15.9268 20.2436 16.1745 19.709C16.4221 19.1743 16.6679 18.4085 17.0211 17.3015C17.4448 15.9741 17.8636 14.603 18.1899 13.411C18.6538 11.7169 19.2965 9.26429 19.8729 7.04027C20.1468 5.98329 20.3344 5.25425 20.4065 4.70452C20.4781 4.15763 20.4114 3.94035 20.3302 3.81803Z"
                                  fill="white" />
                              <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M14.3661 9.61475C14.6425 9.88509 14.6474 10.3283 14.3771 10.6046L10.1815 14.8938C9.91113 15.1702 9.46794 15.1751 9.19157 14.9047C8.91521 14.6344 8.91032 14.1912 9.18066 13.9148L13.3763 9.62567C13.6466 9.3493 14.0898 9.34441 14.3661 9.61475Z"
                                  fill="white" />
                          </svg>
                      </button>
                  </div>
              </div>
          </ng-container>
      </div>
  </div>
  <div class="detailPurchase" id="detailPurchase">
      <ul class="prodDetailTab">
        <li>
            <a
                href="javascript:void()"
                (click)="scrollElement('detailReview')"
                >{{'product.content.lbl.003' | translate}}</a
            >
        </li>
          <li class="on">
              <a
                  href="javascript:void()"
                  (click)="scrollElement('detailPurchase')"
                  >Product Description</a
              >
          </li>
          <li>
              <a href="javascript:void()" (click)="scrollElement('detailImg')"
                  >{{'product.content.lbl.001' | translate}}</a
              >
          </li>
      </ul>
      <div class="purchase">
          <h3>Product Description</h3>
          <div [innerHTML]="remark ? (remark | renderHtml) : ''"></div>
      </div>
  </div>
    <div  class="detailImg" id="detailImg">
        <ul class="prodDetailTab">
          <li>
              <a
                  href="javascript:void()"
                  (click)="scrollElement('detailReview')"
                  >{{'product.content.lbl.003' | translate}}</a
              >
          </li>
          <li>
                <a
                    href="javascript:void()"
                    (click)="scrollElement('detailPurchase')"
                    >Product Description</a
                >
          </li>                
          <li class="on">
              <a href="javascript:void()" (click)="scrollElement('detailImg')"
                  >{{'product.content.lbl.001' | translate}}</a
              >
          </li>
        </ul>
        <ng-container *ngIf="pdtImages.length > 0">
            <ng-container *ngFor="let item of pdtImages">
                <ng-container *ngIf="item.linkInfo">
                    <div
                        class="video-wrapper"
                        [innerHtml]="
                            item.linkInfo | youtubeFrame : 'ytp-iframe'
                        "
                    ></div>
                </ng-container>
                <ng-container
                    *ngIf="item.fileName !== null || item.fileName !== ''"
                >
                    <div class="imgWrap">
                        <img
                            [src]="urlWownet + item.filePath + item.fileName"
                        />
                    </div>
                </ng-container>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="pdtImages.length === 0">
            <div class="imgWrap">
                <img src="./assets/img/test.jpg" alt="" />
            </div>
        </ng-container>
    </div>
  </div>
  
  <paging
    [len]="len"
    [page]="page"
    [config]="config"
    [totalItems]="total"
    (changePage)="onChangePage($event)"
    [turnOnPagination]="true"
    [turnOnTotalItem]="false"
  ></paging>
  
  <div class="popup reviewPopup" [ngClass]="showPopup ? 'opened' : ''">
    <review-popup
        [pdtCd]="pdtCdUrl"
        [openPopup]="showPopup"
        (showPopup)="onOutputShowPopup($event)"
    >
    </review-popup>
  </div>
   -->

   <div class="prodDeBtm">
    <div class="prodDetail" [ngClass]="{'w-100': pdtInfo.cateCd && pdtInfo.cateCd.substr(2,2) == '90'}">
        <div class="prodMenu">
            <a (click)="scrollElement('prodDeImg')" >상품정보</a>
            <a (click)="scrollElement('prodDeDeli')">배송/환불</a>
        </div>
        <div class="prodDeImg" id="prodDeImg">
            <ng-container *ngIf="pdtImages.length > 0">
                <ng-container *ngFor="let item of pdtImages">
                    <ng-container *ngIf="item.linkInfo">
                        <div class="video-wrapper" [innerHtml]="
                                    item.linkInfo | youtubeFrame : 'ytp-iframe'
                                "></div>
                    </ng-container>
                    <ng-container *ngIf="item.fileName !== null || item.fileName !== ''">
                        <div class="imgWrap" [ngClass]="fullImg===true?'fullImg':''">
                            <img [src]="urlWownet + item.filePath + item.fileName" />
                        </div>
                    </ng-container>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="pdtImages.length === 0">
                <div class="imgWrap">
                    <img src="./assets/img/test.jpg" alt="" />
                </div>
            </ng-container>
            <a href="javascript:void(0)" (click)="handleFullImg()" class="imgDetail">상품정보 더보기</a>
        </div>
        <div class="prodDeDeli" id="prodDeDeli">
            <h3>배송</h3>
            <dl>
                <dt>배송</dt>
                <dd>CJ대한통운</dd>
            </dl>
            <dl>
                <dt>배송비</dt>
                <dd>3,000원 (50,000원 이상 구매시 무료배송)</dd>
            </dl>
            <dl>
                <dt>고객센터</dt>
                <dd>오전 10시 ~ 오후 6시까지<br>
                    더조각 채널톡 <a href="http://pf.kakao.com/_xnSsxcxj/chat" target="_blank">http://pf.kakao.com/_xnSsxcxj/chat</a>
                </dd>
            </dl>
            <dl>
                <dt>결제 후 주문취소</dt>
                <dd>오후 1시 이전까지 주문 완료된 경우 당일 출고 되며, 이미 발송된 주문은 취소, 변경이 불가합니다.</dd>
            </dl>
            <!-- <dl>
                <dt>도서산간 추가비용</dt>
                <dd>도서(3,000원), 산간(5,000원)의 추가 비용이 발생합니다.</dd>
            </dl> -->

            <h3>교환/반품</h3>
            <dl>
                <dt>반품/교환 신청</dt>
                <dd>더조각 채널톡 <a href="http://pf.kakao.com/_xnSsxcxj/chat" target="_blank">http://pf.kakao.com/_xnSsxcxj/chat</a></dd>
            </dl>
            <dl>
                <dt>반품/교환이 불가능한 경우</dt>
                <dd>
                    구매자의 책임 있는 사유로 상품이 파손 또는 훼손된 경우<br>
                    유효기간이 경과 되었거나 상품을 개봉하여 훼손하였을 경우<br>
                    상품을 사용하여 재판매가 불가능한 경우<br>
                    상품의 포장이 훼손된 경우
                </dd>
            </dl>
            <dl>
                <dt>신청기간</dt>
                <dd>
                    출고 후 1주일 기간 이내에 신청하여야 합니다.<br>
                    - 교환/반품 접수는 더조각 채널톡으로 접수
                </dd>
            </dl>
            <dl>
                <dt>반품/교환 처리</dt>
                <dd>
                    교환 : 보내주신 상품 확인 후 이상이 없을 시 동일 상품으로 교환됩니다.<br>
                    반품 : 보내주신 상품 확인 후 이상이 없을 시 환불 처리됩니다.
                </dd>
            </dl>
            <dl>
                <dt>환불</dt>
                <dd>
                    현금구매 시 청약 철회 접수 후 1~3영업일 이내에 본인의 계좌로 송금하여 드립니다.<br>
                    카드구매 시 청약 철회 접수 후 1~3영업일 이내에 카드 승인 취소하여 드립니다.
                </dd>
            </dl>
            <dl>
                <dt>반품배송비</dt>
                <dd>편도 3,000원(최초 배송비 무료인 경우 6,000원 부과)</dd>
            </dl>
            <dl>
                <dt>교환배송비</dt>
                <dd>6,000원</dd>
            </dl>
        </div>
    </div>
    <div class="prodSide">
        <div class="posR" *ngIf="pdtInfo.cateCd?.substr(2,2) != '90'">
            <div class="prodOption">
                <div class="optionCont">
                    <h2>{{pdtInfo.pdtName}}</h2>
                    <div class="row">
                        <div class="col-5 optionNum">
                            <a href="javascript:void(0)" (click)="handleOnClickMinus()">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                            </a>
                            <input type="text" [value]="quantity | setComma :'':''" readonly>
                            <a href="javascript:void(0)" (click)="handleOnClickPlus()">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                            </a>
                        </div>
                        <div class="col-7 price" *ngIf="isLogined">
                            {{ 'currency'| translate: { param: pdtInfo.retailAmt | cusprice: pdtInfo.amt | setComma:'price':'' } }}
                        </div>
                        <div class="col-7 price" *ngIf="!isLogined && isRetailAmt">
                            {{ 'currency'| translate: { param: pdtInfo.retailAmt | cusprice: pdtInfo.amt | setComma:'price':'' } }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="sideBtm">
                <div class="row prodTotal">
                    <div class="col-6">
                        총 합계금액
                    </div>
                    <div class="col-6 price" *ngIf="isLogined">
                        {{ 'currency'| translate: { param: totalAmt | setComma:'price':'' } }}
                    </div>
                    <div class="col-6 price" *ngIf="!isLogined && isRetailAmt">
                        {{ 'currency'| translate: { param: totalAmt | setComma:'price':'' } }}
                    </div>
                </div>
                <div class="prodBtns">
                    <a (click)="onClickWishList($event)" class="addWish">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45.18 39.21">
                            <defs>
                                <style>.cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2.5px;}.cls-2{fill:#fff;} .cls-3 {
                                    fill: #D28FBF;
                                    stroke: #fff;
                                    stroke-linecap: round;
                                    stroke-linejoin: round;
                                    stroke-width: 2.5px;
                                }</style>
                            </defs>
                            <g id="레이어_2" data-name="레이어 2">
                                <g id="image">
                                    <path [ngClass]="wishYn == 'Y' ? 'cls-3' : 'cls-1'" d="M43.93,12.79A11.53,11.53,0,0,0,22.59,6.71,11.54,11.54,0,1,0,4.7,21L22.59,38,40.49,21A11.51,11.51,0,0,0,43.93,12.79Z"/>
                                    <path class="cls-t" d="M32.72,7.69A1.53,1.53,0,0,0,33,7.63l-.14,0h.4c.34,0-.2-.06,0,0l.57.15.22.08c.2.07-.26-.13.06,0a5.18,5.18,0,0,1,.57.31L35,8.4s.36.29.09.06a9.3,9.3,0,0,1,1,.92l.24.28c-.22-.26,0,.05.07.11s.23.35.34.53l.16.32c0,.06.19.44.06.11.08.22.16.44.22.67a3.38,3.38,0,0,1,.08.34s0,.08,0,.13,0,.05,0-.12c.09.07,0,.59,0,.7s0,.11,0,.17c0-.19,0-.21,0-.07s0,.23-.08.35-.07.23-.11.34,0,.12,0,0a1.3,1.3,0,0,0-.08.17,1.28,1.28,0,0,0,.44,1.71,1.26,1.26,0,0,0,1.71-.45c1.77-3.63-.89-7.79-4.37-9.16a4.25,4.25,0,0,0-2.68-.19,1.25,1.25,0,1,0,.67,2.41Z"/>
                                </g>
                            </g>
                        </svg>
                    </a>
                    <ul>
                        <li><a (click)="handleOnClickAddToCart();">장바구니</a></li>
                        <li><a (click)="handleOnClickBuyNow();">바로구매</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>